import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import React, {useEffect, useState} from "react";
import AppleLogin from "react-apple-login";
import { useDispatch } from "react-redux";
import {
  FACEBOOK_PROFILE_INFO,
  GOOGLE_PROFILE_INFO,
  RESEND_EMAIL_VERIFICATION,
  ROUTE_MENU,
} from "../../../../constants";
import {
  setLocation,
  useStoreLocation,
} from "../../../../context/StoreLocation";
import {
  useAuthState,
  socialSignIn,
} from "../../../../context/UserAuthentication";
import { Toast_Func } from "../../../../helpers/toast.helper";
import {useNavigate} from "react-router";
import * as CONSTANT from "../../../../constants";
import {brazeSetUser} from "../../../../helpers/brazeHelper";
import { getVisitorId} from "../../../../helpers/helperMethods";
import { trackLogin } from "../../../../analytics/pulseLogin";
import useCheckMobileScreen from "../../../../hooks/useCheckMobileScreen";
import Spinner from "../../../Spinner/Spinner";
import cartItemStyles from "../../CartItems/CartItems.module.scss";
import guestLoginStyles from "./guestLogin.module.scss";
import ValidateEmailModal from "../../../Molecules/Modal/ValidateEmailModal";
import ResendEmailModal from "../../../Molecules/Modal/ResendEmailModal";
import { LoginFormFields } from "../../../../models/forms.model";
import { AppleIcon, GoogleLogo, GuestEmailIcon, GuestAppleIcon } from "../../../../images/svgIcons/svg";

interface ISocialLoginProps {
  socailLoginHide?: string;
  variant?: "default" | "checkout" | "signup";
  onEmailClick?: () => void;
  onCheckoutLoginTrack?: (eventName: string) => void;
  emailIcon?: React.ReactNode;
  isGuestCheckout?: boolean;
  guestCheckoutHandle?: () => void;
}

const SocailLogin = ({
  socailLoginHide = "",
  variant = "default",
  onEmailClick,
  onCheckoutLoginTrack,
  emailIcon,
  isGuestCheckout = false,
  guestCheckoutHandle,
}: ISocialLoginProps) => {
  const { authInfo, dispatch } = useAuthState();
  const [isDeviceIos, setIsDeviceIos] = useState<boolean>(false);
  const { dispatch: locationDispatch } = useStoreLocation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
    const [sendingEmail, setSendingEmail] = React.useState<boolean>(false);
    const [showValidateEmail, setShowValidateEmail] = useState<boolean>(false);
    const [resendEmail, setResendEmail] = useState<boolean>(false);
    const [resendEmailBtnText, setResendEmailBtnText] = useState<string>(
      RESEND_EMAIL_VERIFICATION
    );
    const [resendEmailData, setResendEmailData] = useState<{
      "is_email_sent": boolean,
      "email": string,
      "header":string,
      "body1": string,
      "body2": string
  }>();
    const [resendEmailPayload, setResendEmailPayload] = useState<any>({});
    const initialFormStateForEmailVarification = {
      email: '',
      confirm_email: '',
    };
    const cartDispatch = useDispatch();
  const isItMobile = useCheckMobileScreen();
  const navigate  = useNavigate();
  const pulseLoginContext = {
    isCheckoutLogin: isGuestCheckout || variant === "checkout",
    isSignupPage: variant === "signup",
  };

  const signInWithFacebook = () => {
    FB.login(
      function (response) {
        if (response.status === "connected") {
          let accessToken = response.authResponse.accessToken;
          let user_url = `${FACEBOOK_PROFILE_INFO}${accessToken}`;
          axios
            .get(user_url)
            .then(async (response) => {
              let payload = {
                first_name: response?.data?.first_name,
                last_name: response?.data?.last_name,
                email: response?.data?.email,
                fb_uid: response?.data?.id,
                access_token: accessToken,
                platform: isItMobile ? "MobileWeb" : "web",
              };
              setIsLoading(true)
              await socialSignIn(
                dispatch,
                payload,
                "FACEBOOK_SIGNIN",
                cartDispatch,
                (selectedStore) => {
                  setLocation(locationDispatch, selectedStore);
                },
                true,
                null,
                null,
                pulseLoginContext
              );
            })
            .catch((error) => {
              setIsLoading(false)
              Toast_Func({
                status: false,
                message: "Something went wrong. Please try again",
              });
            });
        }
      },
      {
        enable_profile_selector: true,
        scope: "email,public_profile",
        return_scopes: true,
      }
    );
  };

  const signInWithGoogle = useGoogleLogin({
    scope: "profile email ",
    prompt: "consent",
    onSuccess: (tokenResponse) => {
      const instance = axios.create();
      delete instance.defaults.headers.common["Authorization"];
      instance
        .get(`${GOOGLE_PROFILE_INFO}${tokenResponse.access_token}`)
        .then( async (response) => {
          let payload = {
            access_token: tokenResponse.access_token,
            user: {
              first_name: response.data.given_name,
              last_name: response.data.family_name,
              email: response.data.email,
              platform: isItMobile ? "MobileWeb" : "web",
            },
          };
          setIsLoading(true)
          await socialSignIn(
            dispatch,
            payload,
            "GOOGLE_SIGNIN",
            cartDispatch,
            (selectedStore) => {
              setLocation(locationDispatch, selectedStore);
            },
            true,
            null,
            null,
            pulseLoginContext
          );
          if (isGuestCheckout) {
            guestCheckoutHandle?.();
          }
        })
        .catch((error) => {
          setIsLoading(false)
          Toast_Func({
            status: false,
            message: "Something went wrong. Please try again",
          });
        });
    },
  });

    const signInUserWithoutNewAPICall = (response: any): void => {
      dispatch({ type: 'LOGIN_SUCCESS', payload: response.data.data });
      localStorage.setItem(
        CONSTANT.CURRENT_USER,
        JSON.stringify({ ...response.data.data, visitor_id: getVisitorId() })
      );
      trackLogin({
        userData: response.data.data,
        isItMobile,
        loginMethod: 'Apple',
        ...pulseLoginContext,
      });
      if (isGuestCheckout) {
        guestCheckoutHandle?.();
      }
    };

    const handleEmailVerificationFormSubmission = async (
      values: LoginFormFields,
      { setSubmitting }: any
    ) => {
      let payload: any = {
        ...resendEmailPayload,
        email: values.email,
        visitor_id: getVisitorId(),
        apple_verified: false,
        source: isItMobile ? 'Mobile Web' : 'Web',
        platform: isItMobile ? "MobileWeb" : "web",
      };
      setResendEmailPayload(payload);
      let response = await axios.post(
        `${CONSTANT.CUSTOMER_MICRO_SERVICE}${CONSTANT.APPLE_SIGNIN}`,
        payload
      );
      if (!response?.data?.data?.is_email_sent) {
        signInUserWithoutNewAPICall(response);
      } else if (response.data) {
        setResendEmailData(response?.data?.data);
        setShowValidateEmail(false);
        setResendEmail(true);
      }
    };

  const appleSignInAPI = async (data) => {
    try {
      let payload = {
        is_user_exists: true,
        visitor_id: getVisitorId(),
        platform: isItMobile ? "MobileWeb" : "web",
        ...data,
      };
      let response = await axios.post(
        `${CONSTANT.CUSTOMER_MICRO_SERVICE}${CONSTANT.APPLE_SIGNIN}`,
        payload
      );
      if (
        !response?.data?.data?.is_user_exists &&
        response.data?.data.hasOwnProperty('is_user_exists')
      ) {
        setResendEmailPayload(data);
        setShowValidateEmail(true);
      } else if (!response.data?.data.hasOwnProperty('is_user_exists')) {
        signInUserWithoutNewAPICall(response);
      } else {
        payload = {
          is_user_exists: false,
          apple_verified: true,
          platform: isItMobile ? "MobileWeb" : "web",
          ...data,
        };
        await socialSignIn(
          dispatch,
          payload,
          'APPLE_SIGNIN',
          cartDispatch,
          (selectedStore) => {
            setLocation(locationDispatch, selectedStore);
          },
          true,
          null,
          null,
          pulseLoginContext
        );
      }
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      Toast_Func({ status: false, message: 'Please try again' });
    }
  };

  const signInWithApple = async (response) => {
    try {
      let payload = {
        id_token: response?.authorization?.id_token,
        code: response?.authorization?.code,
        first_name: response?.user?.name?.firstName || null,
        last_name: response?.user?.name?.lastName || null,
      };
      setIsLoading(true);
      appleSignInAPI(payload);
    } catch (error) {
      setIsLoading(false)
      Toast_Func({ status: false, message: "Please try again" });
    }
  };
  useEffect(() => {
    var userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod|Mac/.test(userAgent) && !window.MSStream) {
      setIsDeviceIos(true);
    } else {
      setIsDeviceIos(false);
    }
  }, []);
  useEffect(() => {
    if (authInfo.userId && authInfo.type !== CONSTANT.GUEST_USER) {
      setIsLoading(false)
      brazeSetUser(authInfo.userId)
      if (isGuestCheckout) {
        guestCheckoutHandle?.();
      } else {
        navigate(ROUTE_MENU);
      }
    }
  }, [authInfo])
  const isCheckoutVariant = variant === "checkout";
  const appleLoginButton = (renderProps?: { onClick: () => void }) => (
    <button
      type="button"
      onClick={() => {
        if (isCheckoutVariant) {
          onCheckoutLoginTrack?.(CONSTANT.CHECKOUT_APPLE);
        }
        renderProps?.onClick?.();
      }}
      disabled={isLoading}
      className={`${isCheckoutVariant ? `${guestLoginStyles.loginOptionBtn} ${guestLoginStyles.appleLoginOptionBtn}` : undefined}`}
      aria-label="Continue with Apple"
    >
      {isCheckoutVariant ? (
        <span className={guestLoginStyles.loginOptionContent}>
          <span className={guestLoginStyles.loginOptionIconSlot}>
            <GuestAppleIcon />
          </span>
          <span className={`${guestLoginStyles.loginOptionLabel} font-helvetica-53-extended`}>Apple</span>
        </span>
      ) : (
        <>
          <AppleIcon />
          <span className="social-text">
            Continue with Apple&nbsp;&nbsp;
          </span>
        </>
      )}
    </button>
  );

  const googleLoginButton = (
    <button
      disabled={isLoading}
      type="button"
      onClick={() => {
        if (isCheckoutVariant) {
          onCheckoutLoginTrack?.(CONSTANT.CHECKOUT_GOOGLE);
        }
        (signInWithGoogle as () => void)();
      }}
      className={isCheckoutVariant ? `${guestLoginStyles.loginOptionBtn} ${guestLoginStyles.googleLoginOptionBtn}` : undefined}
      aria-label="Continue with Google"
    >
      {isCheckoutVariant ? (
        <span className={guestLoginStyles.loginOptionContent}>
          <span className={guestLoginStyles.loginOptionIconSlot}>
            <GoogleLogo />
          </span>
          <span className={`${guestLoginStyles.loginOptionLabel} font-helvetica-53-extended`}>Google</span>
        </span>
      ) : (
        <>
          <GoogleLogo />
          <span className="social-text">Continue with Google</span>
        </>
      )}
    </button>
  );

  const renderAppleLogin = () => (
    <li>
      <AppleLogin
        clientId={process.env.REACT_APP_APPLE_SIGNIN_CLIENT_ID}
        scope="name email"
        redirectURI={process.env.REACT_APP_APPLE_SIGNIN_REDIRECT}
        usePopup={true}
        callback={signInWithApple}
        render={(renderProps) => appleLoginButton(renderProps)}
      />
    </li>
  );

  const renderSocialButtons = () => {
    if (isCheckoutVariant) {
      return (
        <>
          <li>
            <button
              type="button"
              onClick={onEmailClick}
              disabled={isLoading}
              className={guestLoginStyles.loginOptionBtn}
              aria-label="Continue with Email"
            >
              <span className={guestLoginStyles.loginOptionContent}>
                <span
                  className={`${guestLoginStyles.loginOptionIconSlot} ${guestLoginStyles.loginOptionIconSlotEmail}`}
                >
                  <GuestEmailIcon />
                </span>
                <span className={`${guestLoginStyles.loginOptionLabel} font-helvetica-53-extended`}>Email</span>
              </span>
            </button>
          </li>
          {isDeviceIos && renderAppleLogin()}
          <li>{googleLoginButton}</li>
        </>
      );
    }

    if (isDeviceIos) {
      return (
        <>
          {renderAppleLogin()}
          <li>{googleLoginButton}</li>
        </>
      );
    }

    return <li>{googleLoginButton}</li>;
  };

  return isLoading ? (
      <Spinner
        className={`${cartItemStyles.cart_spinner} ${isCheckoutVariant ? guestLoginStyles.guestLoginSpinner : ""} mb-4 pb-1`}
        showFooter={"d-none"}
      />
  ) : (
    <>
      <ul
        className={
          isCheckoutVariant
            ? guestLoginStyles.loginOptions
            : `account-social-icons pt-3 w-100 mb-md-0 ${socailLoginHide}`
        }
      >
        {renderSocialButtons()}
      </ul>
      {showValidateEmail &&
        !resendEmail &&
        <ValidateEmailModal
          showValidateEmail={showValidateEmail}
          setShowValidateEmail={setShowValidateEmail}
          initialFormStateForEmailVarification={initialFormStateForEmailVarification}
          handleEmailVerificationFormSubmission={handleEmailVerificationFormSubmission}
          isItMobile={isItMobile}
          addDarkerOverlay={true}
        />
        }
      {!showValidateEmail &&
        resendEmail &&
        <ResendEmailModal
          resendEmail={resendEmail}
          setResendEmail={setResendEmail}
          setShowValidateEmail={setShowValidateEmail}
          resendEmailPayload={resendEmailPayload}
          sendingEmail={sendingEmail}
          setSendingEmail={setSendingEmail}
          setResendEmailData={setResendEmailData}
          resendEmailData={resendEmailData}
          isItMobile={isItMobile}
          setResendEmailBtnText={setResendEmailBtnText}
          resendEmailBtnText={resendEmailBtnText}
          signInUserWithoutNewAPICall={signInUserWithoutNewAPICall}
          addDarkerOverlay={true}
        />
        }
    </>
  );
};

export default SocailLogin;
